/**
 * zg-b2b-options-box.js
 *
 * Plugin for manage options for b2b users in product page
 * - display list of options for box
 * - add multiples options
 *
 * @author: @author: Andrea Basile <abasile [at] zerogrey [dot] com>
 *
 */


/**
 * @event document#b2b.add.options adding multiples products sku
 * @type {object}
 * @property {string} skus - sku's options
 * @property {int} options - list for all options
 */


/* global zgPost, handlebarsTemplates */

(function ($, _) {

    'use strict';

    var root = this;

    /**
     * @selector data-zg-role="comments" The plugin start if there is the selector in the dom when the page load
     */

    var selector = '[data-zg-role="b2b-options-box"]',
				qtyBox = '[data-zg-color="box"]',
				tableSelector = '[data-zg-role="table-options"]',
				totalSelector = '[data-zg-role="total-item"]',
				submit = '[data-zg-role="b2b-options-submit"]';
				
    /**
     * @param {array} [skus] list of all skus
     * @param {array} [options] list of all options
     *
     */

    var DEFAULTS = {
        //DATA
			sizeColor:null,
			skus:null,
			options:null
    };

    /**
     *
     * @param {HTMLElement} element
     * @param {!object}     options
     *
     * @constructor
     */

    var OptionBox = function ( element, options ) {
        this.$element                   = $( element );
        this.options                    = _.extendOwn( _.clone( DEFAULTS ), options || {} );
				this.$tableOptions              = this.$element.find( tableSelector );
				this.$total             				= this.$element.find( totalSelector );
				this.$submit              			= this.$element.find( submit );
       
        // initialize object
				if(this.options.skus != null){
        	this.createGridOptions();
				}else{
					this.createGridCartOptions();
				}
        this.__eventHandlers();
    };
 /**
     * If the products contains messages, the function show the messages and rating
     *
     * @method create Grid for cart
     * @fires document#zg-error Request Failed.
     */

    OptionBox.prototype.createGridCartOptions = function () {

			var data = {
				skus: this.options.optionsPhysic,
				options: this.options.options
			};
			
    	/*SIZE foreach*/
			var firstKey = Object.keys(data.options)[0];
			var secondKey = Object.keys(data.options)[1];
			var size=data.options[firstKey];
			var color=data.options[secondKey];
			var table='<tr class="header"><td><div>&nbsp;</div></td><td><div>BOX</div></td>';
			var sizeTable='';
			for (var key_size in size) {
				table+='<td><div>'+size[key_size]+'</div></td>';
			}	
			table+='</tr>';
			var count=true;
			var box_value=0;
			
			

			/*check if sku is in CMS*/
			var check_sku=0;
			var sizeColor = this.options.sizeColor;
			for (var sku in sizeColor) {
				var boxSizeColor =sizeColor[sku];
				for (var sk in boxSizeColor) {
					var arrCartItems=cartItems[this.options.productId];
						check_sku=boxSizeColor[sk].qty;
						for (var ci in arrCartItems) {
							var ciOptions =arrCartItems[ci][0];
							var optionQuantity=arrCartItems[ci][1];
							var first_key_size = 0;	
							var first_key_color = 0;
							for (var ciOption in ciOptions) {
								if(first_key_size == 0){
									first_key_size = Object.keys(ciOptions[ciOption])[0];									
								}else{
									first_key_color = Object.keys(ciOptions[ciOption])[0];
								}
							}
							if(boxSizeColor[sk].size == first_key_size && first_key_color==first_key_color){
								if( check_sku != 0){
									box_value=optionQuantity/check_sku;
								}
							}							
						}
					}
				}
			
			
			
			
			for (var key_color in color) {
				table+='<tr class="content-grid">';
				
				table+='<td><div>'+color[key_color]+'</div></td>';				
				
				
				
				for (var key_size in size) {
					/*CMS BOX*/
					
					/*check if sku is in CMS*/
					var check_sku=0;
					var sizeColor = this.options.sizeColor;
					for (var sku in sizeColor) {
						var boxSizeColor =sizeColor[sku];
						for (var sk in boxSizeColor) {
							if(boxSizeColor[sk].size==key_size && boxSizeColor[sk].color == key_color){
								check_sku=boxSizeColor[sk].qty;

							}
						}
					}
					if(count){
						table+='<td rowspan="'+Object.keys(color).length+'" class="box-input"><input data-zg-color="box" type="number" min="0" value="'+box_value+'" /></td>';
						count =false;
					}
					table+='<td><input type="number" min="0" data-size="'+key_size+'" data-color="'+key_color+'" value="'+check_sku+'" /><input type="hidden" name="aQty['+this.options.productId+'.'+this.options.optionsPhysic[key_size][key_color]+']" value="'+check_sku+'" /></td>';		
				}	
				
			//sizeTable+='</td>';
				table+='</tr>';
			}	
			
			//sizeTable+='</tr>';
			table+=sizeTable;
			this.$tableOptions.html(table);
			var skus = this.options.skus;
			for (var key in skus) {
				 this.$element.find('[data-size="'+skus[key].options[2]+'"][data-color="'+skus[key].options[4]+'"]').attr('data-sku',key);
			}
			
    };


    /**
     * If the products contains messages, the function show the messages and rating
     *
     * @method create Grid for product
     * @fires document#zg-error Request Failed.
     */

    OptionBox.prototype.createGridOptions = function () {

			var data = {
				skus: this.options.skus,
				options: this.options.options
			};
			
    	/*SIZE foreach*/
			var size=data.options[2].values;
			var color=data.options[4].values;
			var table='<tr class="header"><td><div>&nbsp;</div></td><td><div>BOX</div></td>';
			var sizeTable='';
			for (var key_size in size) {
				table+='<td><div>'+size[key_size].name+'</div></td>';
			}	
			table+='</tr>';
			var count=true;
			
			for (var key_color in color) {
				table+='<tr class="content-grid">';
				
				table+='<td><div>'+color[key_color].name+'</div></td>';
				
				
				if(count){
					table+='<td rowspan="'+Object.keys(color).length+'" class="box-input"><input data-zg-color="box" type="number" min="0" /></td>';
					count =false;
				}
				/*else{
					sizeTable+='</tr><tr class="">';
				}*/
				for (var key_size in size) {
					/*CMS BOX*/
					
					/*check if sku is in CMS*/
					var check_sku=0;
					var sizeColor = this.options.sizeColor;
					for (var sku in sizeColor) {
						var boxSizeColor =sizeColor[sku];
						for (var sk in boxSizeColor) {
							if(boxSizeColor[sk].size==key_size && boxSizeColor[sk].color == key_color){
								check_sku=boxSizeColor[sk].qty;
							}
						}
					}
					table+='<td><input type="number" min="0" data-size="'+key_size+'" data-color="'+key_color+'" disabled value="'+check_sku+'" /></td>';		
				}	
				
			//sizeTable+='</td>';
				table+='</tr>';
			}	
			
			//sizeTable+='</tr>';
			table+=sizeTable;
			this.$tableOptions.html(table);
			var skus = this.options.skus;
			for (var key in skus) {
				 this.$element.find('[data-size="'+skus[key].options[2]+'"][data-color="'+skus[key].options[4]+'"]').attr('data-sku',key);
			}
    };



    /**
     * @method __eventHandlers
     * @listen document#submit.zg.comment. On submit adds the comment to product
     */
    /**
     * @method __eventHandlers
     * @listen document#click.zg.comment. read more or less comment depends if btn clicked has more/less mode value
     *
     */

    OptionBox.prototype.__eventHandlers = function () {
			var t= this;
			t.$element.find('input[data-zg-color="box"]').on('change keypress keyup',function(){
				var totalItem=0;
				var _t = this;
					t.$element.find('input[data-color]').each(function(){
						totalItem+=parseInt($(this).val())*$(_t).val() || 0;
						$(this).next().val(parseInt($(this).val())*$(_t).val() || 0);
				});
				t.options.totalItem=totalItem;
				t.$total.html(totalItem);
			});
			t.$element.find('input[data-zg-color="box"]').trigger('change');
			
			this.$submit.on('click', function(){
				var id= t.options.productId;
				var callback, data = {
            items: []
        };
				var totalItem=0;
				t.$element.find('input'+qtyBox).each(function(){
					var _t=this;
					t.$element.find('[data-color]').each(function(){
						data.items.push({
							product_id: id,
							sku:        $(this).data('sku'),
							quantity:   $(this).val()*$(_t).val() || 0
						});
						totalItem+=$(this).val() || 0;
					});
				});
				if(totalItem !=0){
				callback = {
                success: _.bind( function ( data ) {
                    $( document ).trigger( 'zg.product.addedToCart', [data] );
                }, data ),
                error: function () {
                    // Something went wrong. Request the cart items again.
                    $( document ).trigger( 'zg.getProductList.request-info', ['cart'] );
                }
            };

            zgPost(
                'addProductToCart',
                data,
                {
                    success: window.JS_TRANSLATIONS['add.to.cart.multiple']
                },
                callback
            );
				}
			});
			
		
    };

    // COMMENT PLUGIN DEFINITION
    // =========================
    function Plugin ( option ) {
        return this.each( function () {
            var $this   = $( this );
            var data    = $this.data( 'zg.b2b-options' );
            var options = $.extend( {}, root.ZG_CONFIG || {}, $this.data(), typeof option === 'object' && option );

            if ( !data ) {
                $this.data( 'zg.b2b-options', new OptionBox( this, options ) );
            }
        } );
    }

    $.fn.zg_comment             = Plugin;
    $.fn.zg_comment.Constructor = OptionBox;

    //START PLUGIN
    $( function () {
        $( selector ).each( function () {
            Plugin.call( $( this ) );
        } );
    } );


}).call( this, jQuery, _ );
